<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="closeModal($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="customer-cancel-modal-popup">
    <div class="modal-header">
      <h1 style="display:none;">sonar fix</h1>
      <h2 id="customer-cancel-modal-container">{{cfetLabels.cfet_profile_cancel_modal.heading}}</h2>
      <div class="corner-button">
        <button type="button" id="close-btn" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
          (click)="closeModal($event, 'openModal')" (keyup)="closeModal($event,'openModal')">
          <em aria-label="Close" id="icon-close" class="icon-close modal-close-icon" role="img"></em>
        </button>
      </div>
    </div>
    <div class="modal-body" id="confirmation-buttons-section" modal-content>
      <div id="modal-desc">
        <p id="description" [innerHTML]="cfetLabels.cfet_profile_cancel_modal.description"></p>
      </div>
      <div class="row" id="confirmation-btns">
        <div class="col-md-6">
          <button type="button" id="button-stay" (click)="closeModal($event,'openModal')" (keyup)="closeModal($event,'openModal')"
            class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.stayhere}}</button>
        </div>
        <div class="col-md-6">
          <button type="button" id="button-cancel" (click)="cancelAppln($event,'openModal')"
            (keyup)="cancelAppln($event,'openModal')" class="btn btn-alt btn-medium" tabindex="0"><em
              aria-label=""></em>
            {{cfetButtonLabels.button_labels.cancelapplication}}</button>
        </div>
      </div>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>